import { DateTime } from "luxon"

export enum JobStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    PAUSED = "PAUSED",
}

export enum JobCommand {
    START = "START",
    STOP = "STOP",
    PAUSE = "PAUSE",
}

export type SchedulerJob = Readonly<{
    id: number
    name: string
    cronExpression: string
    lastRun: string
    nextRun: string
    status: JobStatus
}>

export type SchedulerJobDetails = Readonly<{
    id: number
    name: string
    startTime: string
    cronExpression: string
    lastRun: string
    nextRun: string
    status: JobStatus
}>

export type JobScheduleInfo = Readonly<Pick<SchedulerJob, "id" | "lastRun" | "name">>

export type EditSchedulerJobFormValues = Readonly<{
    status: boolean
    startTime: DateTime
    cronExpression: string
}>

export type CombinedJobScheduleInfo = JobScheduleInfo & EditSchedulerJobFormValues

export type EditSchedulerJobBody = Readonly<{
    status: string
    startTime: string
    cronExpression: string
}>
